import Model from '@/models/Model.js';
import axios from '@/plugins/axios';
import { postProctorDashboardForceStatus } from '@/utilities/proctorDashboardForceStatus.js';
import QueryBuilder from '@/utilities/QueryBuilder';

export default class AttemptAuthorization extends Model {
    static entity = 'attempt_authorizations';

    static modelName = 'AttemptAuthorization';

    static fields() {
        return {
            id: this.attr(null),
            activity_id: this.attr(null),
            course_id: this.attr(null),
            user_id: this.attr(null),
            course_enrollment_id: this.attr(null),
            activity_submission_id: this.attr(null),
            activity_type: this.attr(null),
            expires_at: this.attr(null),
            used_at: this.attr(null),
            reason: this.attr(null),
            quiz_time_limit: this.attr(null),
            original_time_limit: this.attr(null),
            comment: this.attr(null),
            statuses: this.attr(null),

            ...super.fields(),

            creator: this.belongsTo('users', 'created_by'),
            activity: this.belongsTo('activities', 'activity_id'),
            course: this.belongsTo('courses', 'course_id'),
            user: this.belongsTo('users', 'user_id'),
            course_enrollment: this.belongsTo('course_enrollments', 'course_enrollment_id'),
            activity_submission: this.belongsTo('activity_submissions', 'activity_submission_id'),
        };
    }

    static searchable() {
        return ['name', 'activity_type', 'reason'];
    }

    async updateStatusToCheckIn() {
        // Status update handled by AttemptAuthorization.update
        AttemptAuthorization.update({
            where: this.id,
            data: {
                statuses: [{ name: 'checked-in' }],
            },
        });
    }

    async startQuiz() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'attempt-started',
            users: [this.user.id],
            proctor_dashboard: true,
            model_type: 'attempt-authorization',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                // Status update handled by AttemptAuthorization.update

                AttemptAuthorization.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'attempt-started' }],
                    },
                });
            }
        } catch (_error) {}
    }

    async updateStatusToWaitingRoom() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'in-waiting-room',
            users: [this.user.id],
            proctor_dashboard: true,
            model_type: 'attempt-authorization',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                // Status update handled by AttemptAuthorization.update

                AttemptAuthorization.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'in-waiting-room' }],
                    },
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    async waitingRoomEnd() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'in-waiting-room-post',
            users: [this.user.id],
            proctor_dashboard: true,
            model_type: 'attempt-authorization',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                // Status update handled by AttemptAuthorization.update

                AttemptAuthorization.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'in-waiting-room-post' }],
                    },
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    async inReview() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: 'in-review',
            users: [this.user.id],
            proctor_dashboard: true,
            model_type: 'attempt-authorization',
            model_id: this.id,
        };

        const forceStatus = new QueryBuilder('quiz-attempt-force-status');

        try {
            const response = await axios.post(forceStatus.toUrl(), payload);

            if (response.status === 200) {
                // Status update handled by AttemptAuthorization.update

                AttemptAuthorization.update({
                    where: this.id,
                    data: {
                        statuses: [{ name: 'in-review' }],
                    },
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    async endQuiz() {
        const payload = {
            quiz_activity_id: this.activity.contentable_id,
            quiz_version_id: this.activity.contentable.quiz_version_id,
            is_preview: false,
            password: null,
            status: '',
            users: [this.user.id],
            proctor_dashboard: true,
            model_type: 'attempt-authorization',
            model_id: this.id,
        };

        await postProctorDashboardForceStatus(payload);

        this.markFinished();
    }

    markFinished() {
        AttemptAuthorization.update({
            where: this.id,
            data: {
                statuses: [{ name: 'finished', created_at: new Date().toISOString() }],
            },
        });
    }
}
